import { CheckoutInfo } from "../../ordering";
import { RArray } from "../../collections";
/**
 * Service for getting information about the order checkout
 */
export class CheckoutInfoService {
    constructor(params) {
        this.rpcService = params.rpcService;
        this.localizationProvider = params.localizationProvider;
        this.isApplePaySupported = params.isApplePaySupported;
    }
    /**
     * @returns basic information about the checkout
     */
    async getCheckoutInfo(restaurantId, timezone) {
        const checkoutInfo = await this.rpcService.rpc("GetCheckoutInfoRequest", {
            restaurantId: restaurantId.value,
            isQrWaiterOrder: false,
            locale: this.localizationProvider.locale,
        });
        return new CheckoutInfo({ checkoutInfo, timezone });
    }
    async getPaymentChannels(restaurantId) {
        const { channels } = await this.rpcService.rpc("GetPaymentChannelsRequest", { restaurantId: restaurantId.value });
        return new RArray(channels);
    }
}
